<div class="auth-page-wrapper d-flex align-items-center justify-content-center min-vh-100 py-5">
  <div class="auth-page-content p-0">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-8 col-xl-7">
          <div class="card border-0 shadow-sm overflow-hidden">
            <div class="card-body p-4 p-md-5 text-center">
              <img
                src="assets/images/error400-cover.png"
                alt="Page introuvable"
                class="img-fluid not-found-illustration mb-4"
              />

              <span class="badge bg-danger-subtle text-danger mb-3">Erreur 404</span>
              <h1 class="h3 mb-2">Oups, cette page est introuvable</h1>
              <p class="text-muted mb-2">
                Le lien est peut-être incorrect, expiré ou vous n'avez pas les droits nécessaires.
              </p>
              <p class="text-muted small mb-4" *ngIf="canShowRequestedPath">
                Chemin demandé: <code>{{ requestedPath }}</code>
              </p>

              <div class="d-flex flex-wrap justify-content-center gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
                  <i class="ri-arrow-left-line me-1"></i> Retour
                </button>

                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="goToDefault()"
                >
                  <i class="ri-home-4-line me-1"></i>
                  {{ isAuthenticated ? 'Aller au tableau de bord' : 'Aller à la connexion' }}
                </button>

                <button type="button" class="btn btn-light" (click)="reloadPage()">
                  <i class="ri-refresh-line me-1"></i> Recharger la page
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
